module.exports = __webpack_public_path__ + "static/media/FOOTER_03.4ddc54ad.webp";